<template>
    <div>
        <v-list-tile
                :to="{ name: 'agent.home' }"
                exact
        >
            <v-list-tile-action>
                <v-icon>home</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
                <v-list-tile-title>Home</v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
                v-if="tienePermiso('Orders')"
                :to="{ name: 'agent.orders.list' }"
        >
            <v-list-tile-action>
                <v-icon>shopping_basket</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
                <v-list-tile-title>Order confirmations</v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
                v-if="tienePermiso('Sample Orders')"
                :to="{ name: 'agent.sample-orders.list' }"
        >
            <v-list-tile-action>
                <v-icon>all_inbox</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
                <v-list-tile-title>Samples requests</v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
    </div>
</template>

<script>

    export default {
        data: () => ({

        }),
        computed : {
            permisos : function(){
                return this.$store.getters.getPermisos;
            }
        },
        created () {
        },
        methods :  {
            tienePermiso(permiso) {
                for (var i = 0; i < this.permisos.length; i++) {
                    if (this.permisos[i] == permiso) {
                        return true;
                    }
                }
                return false;
            }
        },
        components : {
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/shared/menu/AgentMenu.vue